import { DateFormatter } from '@repo/toolkit/date'

import { RadFolderEnum } from '../../types/enums/rad/rad-folder.enum'
import { RadFilters } from '../../types/models/rad/rad'

export const transformRadFiltersToUrl = (filters?: RadFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.type !== undefined) searchParams.append('type', filters.type.toString())
  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.departure) {
    if (filters.departure.startDate)
      searchParams.append('departure_start', filters.departure.startDate)
    if (filters.departure.endDate) searchParams.append('departure_end', filters.departure.endDate)
  }

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  if (filters.location) searchParams.append('location', filters.location)
  if (filters.date) searchParams.append('date', filters.date)
  if (filters.year) searchParams.append('year', filters.year.toString())

  return searchParams.toString()
}

export const transformUrlToRadFilters = (searchParams: URLSearchParams): RadFilters => {
  const filters: RadFilters = {}

  const type = searchParams.get('type')
  if (type) filters.type = type as RadFolderEnum

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',')

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',')

  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',').map(Number)

  const location = searchParams.get('location')
  if (location) filters.location = location

  const date = DateFormatter.checkDateFormat(searchParams.get('date'))
  if (date) filters.date = date

  const year = searchParams.get('year')
  if (year) filters.year = Number(year)

  const departureStart = searchParams.get('departure_start')
  const departureEnd = searchParams.get('departure_end')
  if (departureStart && departureEnd)
    filters.departure = { startDate: departureStart, endDate: departureEnd }

  return filters
}
